export default __webpack_public_path__ + "static/media/ro.028cf08f.svg";